import Image from 'next/image';
import Link from 'next/link';

import { EVENT_NAME, useMoengageEventTracker } from '../../hooks/useMoengage';

import styles from './StiqBanner.module.scss';

function StiqBanner() {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleONBannerClick = () => {
    trackMoengageEvent(EVENT_NAME.TOPPER_BANNER_CTA_CLICKED);
  };

  return (
    <div className={styles.wrapper}>
      <Link
        href="https://www.studyiq.com/course-detail/upsc-ias-live-gs-p2i-foundation-2026-april-morning-batch"
        className={styles.contentWrapper}
        onClick={handleONBannerClick}
      >
        <Image
          src="/images/topper-2025/mobile.png"
          className={styles.mobileImage}
          alt="StudyIQ UPSC Topper 2025 M"
          fill
        />
        <Image
          src="/images/topper-2025/desktop.png"
          className={styles.desktopImage}
          alt="StudyIQ UPSC Topper 2025"
          fill
        />
      </Link>
    </div>
  );
}

export default StiqBanner;
